export const messages = {
  pt: {
    translations: {}
  }
};
